import React, { useEffect, useState } from 'react';
import {
  Container,
  EventText,
  EventTime,
  EventType,
  List,
  ListItem,
  Wrapper
} from './styled';
import { ScoreDetailService } from 'services';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import moment from 'moment';

const SoccerBroadCast = observer(({ gameData }) => {
  const { id } = useParams();
  const [totalItem, setTotalItem] = useState({});
  const [items, setItems] = useState([]);

  useEffect(() => {
    ScoreDetailService.getBroadcastsBySportsType('soccer', id).then((res) => {
      setTotalItem(res);
      let items = [];
      for (let item of Object.values(res)) {
        items = items.concat(item);
      }
      setItems(items);
    });
  }, []);

  return (
    <Container>
      <Wrapper>
        {items.map((item, key) => {
          return <Item key={key} item={item} />;
        })}
      </Wrapper>
    </Container>
  );
});

const Item = ({ item }) => {
  const { displayTime, playText, eventType, locationType, score } = item;

  const formattedTime = moment.duration(displayTime, 'HH:mm').asMinutes();
  const isNotice = locationType === 'TOTAL';
  let splitText = [];
  if (eventType === 'SUBSTITUTE') {
    playText.split(',').map((value, key) => {
      splitText.unshift(<span key={key}>{value}</span>);
    });
  }

  return (
    <ListItem effect={eventType === 'PERIOD_INFO'} isNotice={isNotice}>
      {!isNotice && (
        <EventText locationType={locationType}>
          {eventType !== 'SUBSTITUTE' ? playText : splitText}
        </EventText>
      )}
      <EventType
        eventType={eventType}
        isNotice={isNotice}
        locationType={locationType}
      >
        {playText}
      </EventType>
      {!isNotice && (
        <EventTime locationType={locationType}>{formattedTime}분</EventTime>
      )}
    </ListItem>
  );
};

export default SoccerBroadCast;
